import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/me', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/organizations/:id', () => {
    return HttpResponse.json({});
  }),
  http.get('/api/v1/organizations/:id/users', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
